import React from "react";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import { HeaderBranding } from "./HeaderBranding";
import "./Header.css";

const headerBarClass =
	"header-wrapper header-bar shell-offset sticky top-0 z-40 flex items-center justify-between shadow-sm transition-all duration-300 ease-in-out";

const Header = React.memo(() => {
	return (
		<>
			<header className={headerBarClass}>
				<HeaderBranding />
				<div className="flex shrink-0 items-center gap-2 sm:gap-3">
					<div className="header-action-circle">
						<NotificationBell />
					</div>
					<Profile />
				</div>
			</header>
		</>
	);
});

export default Header;
